import { Component } from 'react';
import PropTypes from 'prop-types';
import { ReactSVG } from 'react-svg';
import hstatic from '../../../../helper/hstatic';
import staticHypotheekbondUrl from '../../../../helper/staticHypotheekbondUrl';

class MessageBoxToggleComponent extends Component {
  render() {
    const {
      onClickHandler,
      iconClass,
      active,
      tabIndex
    } = this.props;

    let svgClassType;

    if (active) {
      svgClassType = iconClass;
    }

    const svgPath = hstatic(`${staticHypotheekbondUrl()}/images/icon/${iconClass}_icon.svg`);

    return (
      <button
        tabIndex={tabIndex}
        className={`message-toggle${active ? ' is-active' : ''}`}
        onClick={onClickHandler}
        type="button"
      >
        <ReactSVG 
          src={svgPath} 
          beforeInjection={(svg) => {
            if (svgClassType) {
              svg.classList.add(svgClassType);
            }
          }}
        />
      </button>
    );
  }
}

MessageBoxToggleComponent.propTypes = {
  onClickHandler: PropTypes.func,
  iconClass: PropTypes.oneOf(['info', 'success', 'warning', 'danger']),
  active: PropTypes.bool,
  tabIndex: PropTypes.number,
};

MessageBoxToggleComponent.defaultProps = {
  onClickHandler: () => {},
  iconClass: 'info',
  active: false,
  tabIndex: -1,
};

export default MessageBoxToggleComponent;
